<script>
  import { docs, docsUpdated, authors } from "../../constants";
  import { page } from "$app/stores";
  import AnchorsList from "$lib/AnchorsList.svelte";
  import Frame from "$lib/Frame.svelte";

  $: slug = $page.params.slug;
  $: doc = docs.find((doc) => doc.slug === slug);
  $: author = authors[doc.author];
</script>

<div class="flex flex-row <sm:flex-col-reverse <sm:text-sm absolute h-full w-full overflow-hidden">
  <aside class="flex flex-col w-md sm:(w-lg max-w-30%) p-10">
    <AnchorsList list={docs} item={doc} />
    <span class="bottom-10 flex-grow font-bold text-xs mt-8 flex flex-col justify-end">最后更新于 {docsUpdated}</span>
  </aside>

  <main class="h-full <sm:h-100vh w-full"><Frame obj={doc} /></main>

  <aside class="flex flex-col gap-2 w-md sm:(w-lg max-w-30%) p-10">
    {#if author.name}
      <div class="flex flex-row items-center gap-1">
        <div class="i-material-symbols-account-circle" />
        <div>{author.name}</div>
      </div>
    {/if}
    {#if author.wechat}
      <div class="flex flex-row items-center gap-1">
        <div class="i-bi-wechat" />
        <div>{author.wechat}</div>
      </div>
    {/if}
    {#if author.email}
      <div class="flex flex-row items-center gap-1">
        <div class="i-tabler-mail-filled" />
        <div>{author.email}</div>
      </div>
    {/if}
    {#if author.donation}
      <img class="max-w-full rounded my-2" src={author.donation} alt="捐赠" />
    {/if}
  </aside>
</div>
